// importing all files
import React from "react";
import styles from "./Navbar.module.css";

// creating a simple navbar
const Navbar = () => {
  return (
    <div className={styles.nav}>
      <h1><i>Calculator App  Project </i> </h1>
    </div>
  );
};

export default Navbar;
